import { memo, useLayoutEffect } from 'react'
import { Route, Routes } from 'weblite-router'
import { RoomStartPage } from '$scenes/room-start-page'
import { VisibilityHandler } from './components/visibility-handler'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { RoomPins } from '$comp/_app/components/chat/room-pins'
import { Room as RoomPage } from '$comp/_app/components/chat/room'

export const Room = memo(() => {
  const isDesktop = useIsDesktopSize()

  useLayoutEffect(() => {
    const scrollToZero = () => window.scrollTo(0, 0)
    window.addEventListener('scroll', scrollToZero)

    return () => {
      window.removeEventListener('scroll', scrollToZero)
    }
  }, [])

  return (
    <VisibilityHandler zIndex={2} considerIOSNotch>
      <Routes>
        <Route name="startPage" element={<RoomStartPage />} />
        <Route
          name="room"
          routeTransitions={{
            name: isDesktop ? 'none' : 'slideLayers',
            keepDisplayMap: { 0: true, 1: true },
          }}
        >
          <Route name="room" element={<RoomPage />} />
          <Route name="pins" element={<RoomPins />} />
        </Route>
      </Routes>
    </VisibilityHandler>
  )
})
